import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, styled } from "@mui/material";
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "transparant",
  color: "var(--font-mine)",
  fontFamily: "'Inter', sans-serif",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "transparant",
  },
  "&.Mui-selected": {
    backgroundColor: "transparant !important",
    "&:hover": {
      backgroundColor: "transparant",
    },
  },
}));
export default function LanguageButton() {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(secureLocalStorage.getItem("lang") || "en");

  useEffect(() => {
    changeLanguage(lang);
  }, [lang]);

  const handleChange = (event) => {
    const newLang = event.target.value;
    setLang(newLang);
    changeLanguage(newLang);
  };

  function changeLanguage(e) {
    i18n.changeLanguage(e);
    secureLocalStorage.setItem("lang", e);
  }

  const languages = ["en", "de", "pl", "fr", "it", "cz", "es"];

  return (
    <FormControl sx={{ minWidth: 50 }}>
      <Select
        value={lang}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        variant="outlined"
        sx={{
          color: "var(--font-mine)",
          fontFamily: "'Inter', sans-serif",
          fontSize: "14px",
          background: "rgba(255, 255, 255, 0.08)",
          borderRadius: "9999px",
          border: "none",
      
          "& .MuiSelect-select": {
            padding: "16px 32px !important", 
          },
      
          "& .MuiSelect-icon": {
            color: '#fff',
          },
      
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "9999px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
          },
      
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderRadius: "9999px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
          },
      
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(255, 255, 255, 0.08) !important",
          },
        }}
        MenuProps={{
          MenuListProps: {
            sx: {
              "& .MuiMenuItem-root": {
                backgroundColor: "transparant",
                color: "var(--font-mine)",
                fontFamily: "'Inter', sans-serif",
                fontSize: "14px",
                "&.Mui-selected": {
                  backgroundColor:
                    "transparant !important",
                },
              },
            },
          },
        }}
      >
        {languages.map((el) => (
          <CustomMenuItem
            value={el}
            key={el}
            sx={{
              background: "transparant",
              color: "var(--font-mine)",
              fontFamily: "'Inter',sans-serif",
              fontSize: "14px",
              "& .Mui-selected": {
                background:
                  "transparant !important",
              },
            }}
          >
            {el.toUpperCase()}
          </CustomMenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
